import React, { useState } from 'react';
import EpisodeOfCareRecord from './EpisodeOfCareRecord';
import { MedicationDetails } from '../dialogs/EpisodeOfCareDetails';

const MedicationRecord = ({ medication, ...props }) => {
  const [visible, setVisible] = useState(false);
  const handleMedicationClick = () => {
    setVisible(true);
  };
  const handleDialogClose = () => setVisible(false);

  return (
    <>
      <MedicationDetails
        medication={medication}
        visible={visible}
        onCancel={handleDialogClose}
      />
      <EpisodeOfCareRecord
        record={medication}
        {...props}
        onClick={handleMedicationClick}
      />
    </>
  );
};

export default MedicationRecord;
